export type RealtimeSeverity = 'delayed' | 'disrupted' | 'cancelled' | 'normal'

const DELAYED = new Set(['DELAYED', 'DELAYED_INDETERMINATE', 'LEG_DELAYED_INDETERMINATE'])

const DISRUPTED = new Set([
  'SERIOUSLY_DISRUPTED',
  'SERIOUSLY_DISRUPTED_INDETERMINATE',
  'BROKEN_UNREPAIRABLE',
  'BROKEN',
  'MISSED_CONNECTION',
])

export function getRealtimeSeverity(classification: string | undefined): RealtimeSeverity {
  if (!classification) return 'normal'
  if (classification === 'CANCELLED') return 'cancelled'
  if (DELAYED.has(classification)) return 'delayed'
  if (DISRUPTED.has(classification)) return 'disrupted'
  return 'normal'
}

export function isRealtimeNormal(classification: string | undefined): boolean {
  return getRealtimeSeverity(classification) === 'normal'
}

export function isJourneyLate(classification: string | undefined): boolean {
  return getRealtimeSeverity(classification) === 'delayed'
}

export function hasPlatformChangeSignal(
  classification: string | undefined,
  platform: string | undefined
): boolean {
  return getRealtimeSeverity(classification) !== 'normal' && Boolean(platform?.trim())
}
